import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import SopBuilder from './SopBuilder.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sops'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'sops_list',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/sops'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'SOPS.HEADER',
          icon: 'flash-settings',
          showBackButton: true,
          keepAlive: false,
        };
      },
      children: [
        {
          path: 'new',
          name: 'sops_new',
          component: SopBuilder,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':sopId/edit',
          name: 'sops_edit',
          component: SopBuilder,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
